import React, { useState, useEffect } from 'react';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Button, fade, IconButton, TableFooter, TablePagination, Tooltip, CircularProgress } from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import clsx from 'clsx';
import ClearIcon from '@material-ui/icons/Clear';
import CheckIcon from '@material-ui/icons/Check';
import {
  Edit,
  CompareArrows,
  ExpandLess,
  ExpandMore,
  FilterNone,
  GroupWork,
  LockOpen,
  Queue,
  UnfoldMore,
  PersonPin,
  VpnKey,
} from '@material-ui/icons';
import PropTypes from 'prop-types';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { useTheme } from '@material-ui/core/styles';
import CmtDropdownMenu from '@coremat/CmtDropdownMenu';
import MoreVert from '@material-ui/icons/MoreVert';
import { httpClient } from 'appUtility/Api';

const useStyles = makeStyles(theme => ({
  scrollbarRoot: {
    // height: 251,
    marginLeft: -24,
    marginRight: -24,
    [theme.breakpoints.up('xl')]: {
      // height: 269,
    },
  },
  tableRowRoot: {
    position: 'relative',
    transition: 'all .2s',
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    '&:hover': {
      backgroundColor: fade(theme.palette.primary.main, 0.08),
      transform: 'translateY(-4px)',
      boxShadow: `0 3px 10px 0 ${fade(theme.palette.common.dark, 0.2)}`,
      borderTopColor: 'transparent',
      '& $tableCellRoot': {
        color: theme.palette.text.primary,
        '&:last-child': {
          color: theme.palette.error.main,
        },
        '&.success': {
          color: theme.palette.success.main,
        },
      },
    },
    '&:last-child': {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
  },
  tableCellRoot: {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 5,
    paddingBottom: 5,
    fontSize: 14,
    letterSpacing: 0.4,
    color: theme.palette.common.dark,
    borderBottom: '0 none',
    '&:first-child': {
      paddingLeft: 24,
    },
    '&:last-child': {
      textAlign: 'right',
      paddingRight: 24,
    },
  },
  tableCellWidth: {
    minWidth: '200px',
  },
  tableRowCellRoot: {
    fontSize: 12,
    '&:last-child': {
      paddingRight: 64,
      '& .MuiSvgIcon-root': {
        display: 'none',
      },
    },
    '& .MuiSvgIcon-root': {
      fontSize: '13px',
      position: 'relative',
      top: '2px',
      cursor: 'pointer',
    },
  },
  blockRoot: {
    display: 'block',
    fontSize: 14,
  },
  loader: {
    position: 'relative',
    height: '150px',
  },
  loadingSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
  flexBtn: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles();
  const { count, page, rowsPerPage, onPageChange } = props;
  const theme = useTheme();

  const handleBackButtonClick = event => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = event => {
    onPageChange(event, page + 1);
  };

  return (
    <div className={classes.flexBtn}>
      <IconButton onClick={handleBackButtonClick} disabled={page === 1} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage)} aria-label="next page">
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const ProductsTable = ({
  columns,
  activateTable,
  enableTable,
  selectedProducts,
  handleEdit,
  handleActivate,
  handleDeactivate,
  productData,
  handleViewContact,
  handleResetPassword,
  handleDisableAccess,
  handleEnableAccess,
  loading,
  handleSort,
  rowsPerPage,
  page,
  total,
  handleChangePage,
  handleChangeRowsPerPage,
  toTable,
  fromTable,
  currentColumn,
  direction,
}) => {
  const classes = useStyles();
  const [active, setActive] = useState(false);
  const [adminAccess, setAdminAccess] = useState(false);
  const [rowID, setRowID] = useState('');
  var [contactData, setContactData] = useState([]);

  contactData = selectedProducts && selectedProducts;

  const actions = [
    {
      icon: <Edit color="secondary" fontSize="small" />,
      label: 'Edit Contact',
      onClick: handleEdit,
    },
    {
      icon: <LockOpen color="secondary" fontSize="small" />,
      label: active ? 'Deactivate' : 'Activate',
      onClick: active ? handleDeactivate : handleActivate,
    },
    {
      icon: <PersonPin color="secondary" fontSize="small" />,
      label: adminAccess ? 'Disable Admin Access' : 'Enable Admin Access',
      onClick: adminAccess ? handleDisableAccess : handleEnableAccess,
    },
  ];

  const actions2 = [
    {
      icon: <Edit color="secondary" fontSize="small" />,
      label: 'Edit Contact',
      onClick: handleEdit,
    },
    {
      icon: <LockOpen color="secondary" fontSize="small" />,
      label: active ? 'Deactivate' : 'Activate',
      onClick: active ? handleDeactivate : handleActivate,
    },
    {
      icon: <PersonPin color="secondary" fontSize="small" />,
      label: adminAccess ? 'Disable Admin Access' : 'Enable Admin Access',
      onClick: adminAccess ? handleDisableAccess : handleEnableAccess,
    },

    {
      icon: <VpnKey color="secondary" fontSize="small" />,
      label: 'Reset Password',
      onClick: handleResetPassword,
    },
  ];

  useEffect(() => {
    contactData.map(item => {
      if (item.contactID === rowID) {
        (item.contactActive === 1 || item.contactActive === true) ? setActive(true) : setActive(false);
        (item.hasAccessToAdminPanel === 1 || item.hasAccessToAdminPanel === true) ? setAdminAccess(true) : setAdminAccess(false);
      }
    });
  }, [rowID]);

  // useEffect(() => {
  //   Activate/Deactivate
  //   if(activateTable === "handleActivate"){
  //     setActive(true);
  //   }else if(activateTable === "handleDeactivate" ){
  //     setActive(false);
  //   }else{}

  //   // Enable/Disable
  //   if(enableTable === "handleEnable"){
  //     setAdminAccess(true);
  //   }else if(enableTable === "handleDisable"){
  //     setAdminAccess(false);
  //   }else {}

  // },[selectedProducts])

  useEffect(() => {
    if (productData.hasAccessToAdminPanel == true) {
      setAdminAccess(true);
    } else if (productData.hasAccessToAdminPanel == false) {
      setAdminAccess(false);
    } else {
    }

    if (productData.contactActive == true) {
      setActive(true);
    } else if (productData.contactActive == false) {
      setActive(false);
    } else {
    }

    contactData &&
      contactData.map(contact => {
        if (contact.contactID == productData.contactID) {
          return (
            (contact.contactActive = productData.contactActive),
            (contact.hasAccessToAdminPanel = productData.hasAccessToAdminPanel)
          );
        }
      });
      setContactData(contactData);
  }, [productData]);

  // console.log('contact data', contactData);

  const handleRowID = (e, id) => {
    setRowID(id);
  };

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };
  // const handleChangeRowsPerPage = event => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  return (
    <PerfectScrollbar className={classes.scrollbarRoot}>
      <Box className="Cmt-table-responsive">
        <Table>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell
                  key={column.id}
                  onClick={() => handleSort(column)}
                  className={clsx(classes.tableCellRoot, classes.tableRowCellRoot)}>
                  {' '}
                  {currentColumn === column ? <span style={{ fontWeight: '900' }}>{column.label}</span> : column.label}
                  {currentColumn === column ? direction ? <ExpandLess /> : <ExpandMore /> : <UnfoldMore />}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {loading ? (
            <TableBody className={classes.loader}>
              <Box textAlign="center" className={classes.loadingSection}>
                <CircularProgress />
              </Box>
            </TableBody>
          ) : (
            <TableBody>
              {contactData &&
                contactData.map((row, index) => {
                  return (
                    <TableRow className={classes.tableRowRoot} key={Math.random()}>
                      <TableCell className={classes.tableCellRoot}>{row.firstName}</TableCell>
                      <TableCell className={classes.tableCellRoot}>{row.lastName}</TableCell>
                      <TableCell className={classes.tableCellRoot}>{row.position}</TableCell>
                      <TableCell className={classes.tableCellRoot}>{row.email_username}</TableCell>

                      <TableCell className={classes.tableCellRoot}>
                        {row.primaryContact === 1 ? (
                          <CheckIcon fontSize="small" color="primary" />
                        ) : (
                          <ClearIcon fontSize="small" color="secondary" />
                        )}
                      </TableCell>
                      <TableCell className={classes.tableCellRoot}>
                        {(row.hasAccessToAdminPanel === 1 || row.hasAccessToAdminPanel === true) ? (
                          <CheckIcon fontSize="small" color="primary" />
                        ) : (
                          <ClearIcon fontSize="small" color="secondary" />
                        )}
                      </TableCell>
                      <TableCell className={classes.tableCellRoot}>
                        {(row.contactActive === 1 || row.contactActive === true) ? (
                          <CheckIcon fontSize="small" color="primary" />
                        ) : (
                          <ClearIcon fontSize="small" color="secondary" />
                        )}
                      </TableCell>

                      <TableCell className={classes.tableCellRoot} onMouseOver={e => handleRowID(e, row.contactID)}>
                        <Box display="flex" alignItems="center" justifyContent="flex-end">
                          {/* {row.sales_data.income} */}
                          <CmtDropdownMenu
                            TriggerComponent={
                              <Tooltip title="More">
                                <IconButton size="small" style={{ marginLeft: 10 }}>
                                  <MoreVert />
                                </IconButton>
                              </Tooltip>
                            }
                            items={(row.hasAccessToAdminPanel === 1 || row.hasAccessToAdminPanel === true) ? actions2 : actions}
                            memID={row.contactID}
                            // onItemClick={(e) => handleRowID(e,row.inventoryOrderID)}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {selectedProducts.length === 0 && (
                <TableRow
                  style={{
                    textAlign: 'center',
                    width: '100%',
                    position: 'absolute',
                  }}>
                  No Contacts
                </TableRow>
              )}
            </TableBody>
          )}
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[20, 50, 70, 100]}
                rowsPerPage={rowsPerPage}
                page={page}
                count={total && total}
                SelectProps={{
                  native: true,
                }}
                labelDisplayedRows={() =>
                  `${fromTable == null ? 0 : fromTable} - ${toTable == null ? 0 : toTable} to ${total}`
                }
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Box>
    </PerfectScrollbar>
  );
};

export default ProductsTable;
